import axios from 'axios';
import { API_BASE_URL } from '../config/api';

const API_URL = `${API_BASE_URL}/auth/users`;

const userService = {
  getUsers: async (token, params = {}) => {
    const response = await axios.get(API_URL + '/', {
      headers: { Authorization: `Token ${token}` },
      params
    });
    return response.data;
  },

  getUser: async (token, userId) => {
    const response = await axios.get(`${API_URL}/${userId}/`, {
      headers: { Authorization: `Token ${token}` }
    });
    return response.data;
  },

  createUser: async (token, userData) => {
    const response = await axios.post(API_URL + '/', userData, {
      headers: { Authorization: `Token ${token}` }
    });
    return response.data;
  },

  updateUser: async (token, userId, userData) => {
    const response = await axios.put(`${API_URL}/${userId}/`, userData, {
      headers: { Authorization: `Token ${token}` }
    });
    return response.data;
  },

  toggleActive: async (token, userId, isActive) => {
    const response = await axios.patch(`${API_URL}/${userId}/active/`, { is_active: isActive }, {
      headers: { Authorization: `Token ${token}` }
    });
    return response.data;
  },

  deleteUser: async (token, userId) => {
    const response = await axios.delete(`${API_URL}/${userId}/`, {
      headers: { Authorization: `Token ${token}` }
    });
    return response.data;
  },
};

export default userService;
